import { memo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useThemeMode } from 'context';

/** Kun/Tun rejimini almashtirish tugmasi (tanlov localStorage'da saqlanadi) */
const ThemeModeToggle = () => {
  const { t } = useTranslation();
  const { isDark, toggleMode } = useThemeMode();
  const label = isDark ? t('common.theme.light') : t('common.theme.dark');

  return (
    <Tooltip title={label} arrow>
      <IconButton
        size='small'
        onClick={toggleMode}
        aria-label={label}
        className='!rounded-lg !text-muted'
      >
        <i className={isDark ? 'bi bi-sun' : 'bi bi-moon'} />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ThemeModeToggle);
